import Process from "process";
import { Buffer } from "buffer";

// for csv-stringify polyfill
// https://github.com/vitejs/vite/discussions/2785
globalThis.process = Process;
globalThis.Buffer = Buffer;
